'use client';

import { useEffect, useState } from 'react';

function detectStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const mql = window.matchMedia?.('(display-mode: standalone)');
  const iosStandalone = (window.navigator as { standalone?: boolean }).standalone === true;
  return Boolean(mql?.matches) || iosStandalone;
}

/** Whether Ertzyx is currently running as an installed/standalone PWA (not a browser tab). */
export function useStandaloneDisplayMode(): boolean {
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    setIsStandalone(detectStandalone());
    const mql = window.matchMedia?.('(display-mode: standalone)');
    if (!mql) return;
    const onChange = () => setIsStandalone(detectStandalone());
    mql.addEventListener?.('change', onChange);
    return () => mql.removeEventListener?.('change', onChange);
  }, []);

  return isStandalone;
}
